import { render } from "./TabsWrapper.vue?vue&type=template&id=3cc46a5e"
import script from "./TabsWrapper.vue?vue&type=script&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__